import { apiClient } from "../../../services/apiClient";
import { IReportResponse } from "../Interfaces/IReportsInterface";

export async function getReports(): Promise<IReportResponse> {
  const { data } = await apiClient.get<IReportResponse>(`/reports/myevaluations`);
  return data;
}